import * as React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import { Button } from '@mui/material';
import { useState, useEffect } from "react";
import { customToastify } from "../components/pages/utils/utilsFunctions"
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import Chip from '@mui/material/Chip';



const SERVER_URL = `${process.env.REACT_APP_SITEURL}`;


function Media(props) {
  const { loading = false, allSubtitles } = props;

  return (
    <Grid container wrap="wrap" sx={{ justifyContent: "center" }}>
      {(allSubtitles).map((item, index) => (
        <Box key={index} sx={{ width: 210, mx: 0.5, mt: 1, border: "dashed 1px", borderRadius: "5px" }}>
          <Box sx={{ textAlign: "center" }}>
            {/* <Button>
                مشاهده
              </Button> */}
            <Button sx={{ m: 1 }} variant="contained" onClick={() => {
              navigator.clipboard.writeText(item.subtitlesUploadId)
              customToastify("info", `آی دی : ${item.subtitlesUploadId} کپی شد`)
            }}>
              {item.subtitlesUploadId}
              {item.type == "umlang" ? <StarIcon sx={{ color: "#ffee07" }} /> : null}
              {item.type == "managerUpload" ? <StarHalfIcon sx={{ color: "#ffee07" }} /> : null}
            </Button>
          </Box>

          <Box sx={{ width: 210, height: 250, backgroundImage: `url("${item.coverUrl}")`, backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundPosition: "center" }}>

          </Box>
          <Box sx={{ pr: 2 }}>
            <Typography gutterBottom variant="body2">
              {item.nameOfMovie}
            </Typography>
            <Typography display="block" variant="caption" color="text.secondary">
              زبان : {languagesList[item.subtitlesLanguage]}
            </Typography>
            {item.season ? <Typography variant="caption" color="text.secondary">
              {`فصل:${item.season} • قسمت: ${item.episode}`}
            </Typography> : null}
            {item["otherTags"].length > 0 ? item["otherTags"].map((tag, idx) => (<Chip key={`tag-${idx}`} size='small' label={tag} />)) : null}
          </Box>
        </Box>
      ))}
    </Grid>
  );
}

Media.propTypes = {
  loading: PropTypes.bool,
};

export default function ShowResult(props) {
  const { subtitlesList } = props
  const [allSubtitles, setSllSubtitles] = useState([]);

  useEffect(() => {
    setSllSubtitles(subtitlesList)
  }, [subtitlesList])
  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Media allSubtitles={allSubtitles} />
    </Box>
  );
}

const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
